class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    
    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );


      // ***********************************

/* ===== Robust autofocus block (replace previous one) ===== */
const TRIGGER_SELECTOR = [
  '.header__icon--search',
  '[data-search-trigger]',
  '.search-toggle',
  '[aria-controls="SearchDrawer"]',
  'button[name="search"]',
  '.header__search-toggle'
].join(',');

// Focus only when the input is actually visible
function focusWhenVisible(el, maxMs = 1200) {
  const start = performance.now();
  function visible(e) {
    // visible if not display:none and within layout flow
    return e && e.offsetParent !== null && getComputedStyle(e).visibility !== 'hidden';
  }
  function tick() {
    if (!el) return;
    if (visible(el)) {
      el.focus({ preventScroll: true });
      // put caret at end if value exists
      const v = el.value; el.value = ''; el.value = v;
      return;
    }
    if (performance.now() - start < maxMs) {
      requestAnimationFrame(tick);
    }
  }
  requestAnimationFrame(tick);
}

const focusSoon = () => {
  if (!this.input) return;
  // try immediately, then keep retrying until visible
  focusWhenVisible(this.input);
};

// 1) Clicks on any search trigger
document.addEventListener('pointerup', (e) => {
  if (e.target.closest(TRIGGER_SELECTOR)) focusSoon();
});
document.addEventListener('click', (e) => {
  if (e.target.closest(TRIGGER_SELECTOR)) focusSoon();
});

// 2) If wrapped in a <details> drawer, focus on open
const details = this.closest('details');
if (details) {
  details.addEventListener('toggle', () => {
    if (details.open) focusSoon();
  });
}

// 3) If there’s a dialog/drawer container, focus after its animation
const drawer = this.closest('#SearchDrawer, [data-search-drawer], .search-modal, .search-drawer');
if (drawer) {
  ['transitionend', 'animationend'].forEach(evt => drawer.addEventListener(evt, focusSoon));
}

// 4) As a last resort, when predictive results mount, re-focus input
const results = document.getElementById('predictive-search-results');
if (results && 'MutationObserver' in window) {
  const mo = new MutationObserver(() => focusSoon());
  mo.observe(results, { childList: true, subtree: true });
}

// 5) Bonus UX: Press "/" to focus search from anywhere (common pattern)
document.addEventListener('keydown', (e) => {
  if (e.key === '/' && !/input|textarea|select/i.test(document.activeElement.tagName)) {
    e.preventDefault();
    focusSoon();
  }
});
/* ===== End robust autofocus block ===== */


      //*****************************************
      
      
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    event.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
